import React from "react";
import ScrollAnimation from "react-animate-on-scroll";

export default function Resume() {
  return (
    <div className="row" id="resume">
      <div className="col-sm-12">
        <ScrollAnimation animateIn="slideInDown" animateOut="slideOutUp">
          <h1 className="title title--h1 title__separate">Resume</h1>
        </ScrollAnimation>
      </div>
      <div className="col-12 col-lg-6">
        <h2 className="title title--h3">
          <img className="title-icon" src="assets/icons/icon-experience.svg" alt="" /> Experience
        </h2>
        <div className="timeline">
          <article className="timeline__item">
            <h5 className="title title--h5 timeline__title">Download my latest resume</h5>
            <span className="timeline__period">September 2015 — Present</span>
            <br />
            <i className="text-muted">
              <small>- Using JavaScript, TypeScript, React.js, Redux, HTML5, CSS3</small>
            </i>
            <br />
            <a
              className="btn-flat"
              type="button"
              href="https://drive.google.com/file/d/1-6j63iEmX86ULXmht_9anqQrk6346Nws/view?usp=share_link"
            >
              Dowload Resume
            </a>
            <hr />
          </article>
        </div>
      </div>
      <div className="col-12 col-lg-6">
        <h2 className="title title--h3">
          <img className="title-icon" src="assets/icons/icon-education.svg" alt="" /> Education
        </h2>
        <div className="timeline">
          <article className="timeline__item">
            <h5 className="title title--h5 timeline__title">ENUGU STATE UNIVERSITY OF SCIENCE AND TECHNOLOGY</h5>
            <span className="timeline__period">2010 — 2015</span>
            <p className="timeline__description">
              • Tertiary Education <br />
              • Mechanical Engineering
              <br />
              • B.Eng.
              <br />• C.G.P Available on request.
            </p>
          </article>
        </div>
      </div>
    </div>
  );
}
